import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLanguage } from "../i18n";
import { Reveal, Eyebrow } from "./Reveal";
import { PhotoSlot } from "./PhotoSlot";
import { IMAGES, PHOTOS, SHOW_PHOTOS } from "../data";

export const Story = () => {
  const { t } = useLanguage();
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: imgRef,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section
      id="storia"
      data-testid="family-story-section"
      className="relative py-24 sm:py-36"
      style={{ backgroundColor: "#F5EFE6" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-14 lg:gap-8 items-center">
        <div className="lg:col-span-5 lg:col-start-1 order-2 lg:order-1">
          <Reveal>
            <div ref={imgRef} className="relative">
              <div className="absolute -top-4 -left-4 w-full h-full border border-[#480A1A]/20 pointer-events-none" />
              <div className="overflow-hidden aspect-[4/5]">
                <motion.img
                  src={PHOTOS.sketches}
                  alt="Gli studi preliminari di Sant'Irene"
                  style={{ y }}
                  className="w-full h-[112%] object-cover object-[30%_center]"
                />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
          <Reveal>
            <div className="flex items-baseline gap-5">
              <span className="font-display italic font-light text-6xl sm:text-7xl text-[#480A1A]/15 leading-none">
                01
              </span>
              <Eyebrow>{t.story.eyebrow}</Eyebrow>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-light text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.15] tracking-tight text-[#2C0F1A]">
              {t.story.title}
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-8 text-base leading-relaxed text-[#5A4440]">{t.story.desc1}</p>
          </Reveal>
          <Reveal delay={0.26}>
            <p className="mt-5 text-base leading-relaxed text-[#5A4440]">{t.story.desc2}</p>
          </Reveal>
          <Reveal delay={0.34}>
            <blockquote
              data-testid="family-story-quote"
              className="mt-10 pl-6 border-l-2 border-[#C69255]"
            >
              <p className="font-display italic text-xl sm:text-2xl leading-snug text-[#480A1A]">
                {t.story.quote}
              </p>
              <footer className="mt-4 font-meta text-[10px] uppercase tracking-[0.3em] text-[#A5713C]">
                {t.story.signature}
              </footer>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
